import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CheckIbanComponent} from './pages/check-iban/check-iban.component';
import {adminGuard, aniaAndminGuard, aniaGuard, loginGuard, profileGuard, smsAdminGuard, smsGuard, smartSummaryGuard, ibanCheckGuard, adminSmartSummaryGuard} from "./guards/auth.guard";
import {UnauthorizedComponent} from "./pages/unauthorized/unauthorized.component";
import {MainContainerComponent} from "./components/main-container/main-container.component";
import {environment} from 'environments/environment';
import {CallbackComponent} from "./pages/callback/callback.component";
import {EndSessionComponent} from "./pages/end-session/end-session.component";
import { QuicksightComponent } from './pages/quicksight/quicksight.component';
import { SicAniaComponent } from './pages/sic-ania/sic-ania.component';
import { SmsSenderComponent } from './pages/sms-sender/sms-sender.component';
import { QuicksightSicAniaComponent } from './pages/quicksight-sic-ania/quicksight-sic-ania.component';
import { QuicksightSmsSenderComponent } from './pages/quicksight-sms-sender/quicksight-sms-sender.component';
import {SmartSummaryComponent} from "./pages/smart-summary/smart-summary.component";
import { QuicksightSmartSummaryComponent } from './pages/quicksight-smart-summary/quicksight-smart-summary.component';


const routes: Routes = [
  {
    path: '', component: MainContainerComponent, canActivate: [loginGuard],
    children: [
      /*{path: '', redirectTo: 'check-iban', pathMatch: 'full'},*/
      {path: 'check-iban', component: CheckIbanComponent, canActivate: [profileGuard, ibanCheckGuard]},
      {path: 'quicksight', component: QuicksightComponent, canActivate: [profileGuard, adminGuard]},
      {path: 'sic-ania', component: SicAniaComponent, canActivate: [profileGuard, aniaGuard] },
      {path: 'sms-sender', component: SmsSenderComponent, canActivate: [profileGuard, smsGuard] },
      {path: 'quicksight-sic-ania', component: QuicksightSicAniaComponent, canActivate: [profileGuard, aniaAndminGuard]},
      {path: 'quicksight-sms-sender', component: QuicksightSmsSenderComponent, canActivate: [profileGuard,smsAdminGuard]},
      {path: 'quicksight-smart-summary', component: QuicksightSmartSummaryComponent, canActivate: [profileGuard, adminSmartSummaryGuard]},
      {path: 'smart-summary', component: SmartSummaryComponent, canActivate: [profileGuard, smartSummaryGuard]},
    ]
  },
  {path: 'unauthorized', component: UnauthorizedComponent},
  {path: 'end-session', component: EndSessionComponent},
  {path: environment.callbackPath, component: CallbackComponent},
  {path: '**', redirectTo: '/', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
